import React from 'react';

import images from './images';

const CardImage = ({ activeCard, imageName, cardName }) => (
  <img className={activeCard !== cardName ? 'cardIcon' : 'cardIconCheck'} src={images[imageName]} alt={imageName} />
);

export default CardImage;
